// 导入 Day.js 语言包，用于 Element Plus 日期组件
// 参考：https://element-plus.org/zh-CN/guide/i18n#日期和时间本地化
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/zh-tw'
import 'dayjs/locale/en'

export default defineNuxtPlugin(() => {
  // Day.js locale will be set by i18n plugin automatically
})
